import React, { useState } from 'react';
import { Heart, Mail, Phone, MapPin } from 'lucide-react';
import { LegalModal } from './LegalModal';
import { useTranslation } from '../i18n/LanguageContext';
export function Footer() {
  const {
    t
  } = useTranslation();
  const [modal, setModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-lavender-50 pt-16 pb-8 border-t border-lavender-100" data-id="element-218">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-219">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-220">
            <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-221">
              <div className="w-20 h-20 rounded-full overflow-hidden border-4 border-white shadow-md mb-4" data-id="element-222">
                <img src="https://cdn.magicpatterns.com/uploads/5GKd3WcM4VNULi49z2wXh8/Logo_Final.jpg" alt="FerbyStore Logo" className="w-full h-full object-cover" data-id="element-223" />
              </div>
              <h3 className="font-serif text-2xl text-gray-900 mb-2" data-id="element-224">
                FerbyStore
              </h3>
              <p className="font-script text-xl text-lavender-600 mb-4" data-id="element-225">
                {t.footer.tagline}
              </p>
              <div className="flex items-center text-gray-500 text-sm" data-id="element-226">
                <Heart className="w-4 h-4 text-blush-500 mr-1 fill-blush-500" data-id="element-227" />
                <span data-id="element-228">{t.footer.crafted}</span>
              </div>
            </div>

            <div className="flex flex-col items-center md:items-start" data-id="element-229">
              <h4 className="font-serif text-lg font-semibold text-gray-900 mb-4" data-id="element-230">
                {t.footer.exploreHeading}
              </h4>
              <ul className="space-y-3 text-center md:text-left" data-id="element-231">
                <li data-id="element-232">
                  <a href="#collection" className="text-gray-600 hover:text-lavender-600 transition-colors" data-id="element-233">
                    {t.footer.links.collection}
                  </a>
                </li>
                <li data-id="element-234">
                  <a href="#ferbytouch" className="text-gray-600 hover:text-lavender-600 transition-colors" data-id="element-235">
                    {t.footer.links.ferbytouch}
                  </a>
                </li>
                <li data-id="element-236">
                  <a href="#testimonials" className="text-gray-600 hover:text-lavender-600 transition-colors" data-id="element-237">
                    {t.footer.links.stories}
                  </a>
                </li>
                <li data-id="element-238">
                  <a href="#promise" className="text-gray-600 hover:text-lavender-600 transition-colors" data-id="element-239">
                    {t.footer.links.promise}
                  </a>
                </li>
              </ul>
            </div>

            <div className="flex flex-col items-center md:items-start" data-id="element-240">
              <h4 className="font-serif text-lg font-semibold text-gray-900 mb-4" data-id="element-241">
                {t.footer.contactHeading}
              </h4>
              <ul className="space-y-4" data-id="element-242">
                <li data-id="element-243">
                  <a href="mailto:ferbystore4@gmail.com" className="flex items-center text-gray-600 hover:text-lavender-600 transition-colors group" data-id="element-244">
                    <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center mr-3 shadow-sm group-hover:bg-lavender-100 transition-colors" data-id="element-245">
                      <Mail className="w-4 h-4 text-lavender-500" data-id="element-246" />
                    </div>
                    ferbystore4@gmail.com
                  </a>
                </li>
                <li data-id="element-247">
                  <a href="tel:385-549-3420" className="flex items-center text-gray-600 hover:text-lavender-600 transition-colors group" data-id="element-248">
                    <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center mr-3 shadow-sm group-hover:bg-lavender-100 transition-colors" data-id="element-249">
                      <Phone className="w-4 h-4 text-lavender-500" data-id="element-250" />
                    </div>
                    385-549-3420
                  </a>
                </li>
                <li className="flex items-start text-gray-600" data-id="element-251">
                  <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center mr-3 shadow-sm flex-shrink-0 mt-1" data-id="element-252">
                    <MapPin className="w-4 h-4 text-lavender-500" data-id="element-253" />
                  </div>
                  <span style={{
                  whiteSpace: 'pre-line'
                }} data-id="element-254">
                    {t.footer.address}
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="pt-8 border-t border-lavender-200/50 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-255">
            <p className="text-gray-500 text-sm text-center md:text-left" data-id="element-256">
              {t.footer.copyright.replace('{year}', String(new Date().getFullYear()))}
            </p>
            <div className="flex space-x-6" data-id="element-257">
              <button type="button" onClick={() => setModal('privacy')} className="text-gray-400 hover:text-lavender-500 text-sm transition-colors" data-id="element-258">
                {t.footer.privacy}
              </button>
              <button type="button" onClick={() => setModal('terms')} className="text-gray-400 hover:text-lavender-500 text-sm transition-colors" data-id="element-259">
                {t.footer.terms}
              </button>
            </div>
          </div>
        </div>
      </footer>

      <LegalModal open={modal !== null} type={modal} onClose={() => setModal(null)} data-id="element-260" />
    </>;
}